import GUI from 'lil-gui';
import { Ticker } from '~/Chrono/Types';

let _gui: GUI = null;
let _fps: number = 0;
let _previousDeltas: Array<number> = [];

/**
 * @return {void}
 */
export function DebugGetFps(): number
{
    return _fps;
}

/**
 * @return {void}
 */
export function DebugUpdate(ticker: Ticker): void
{
    _previousDeltas.push(ticker.delta);

    if (_previousDeltas.length === 180) {
        _previousDeltas.shift();
    }

    let length = _previousDeltas.length;

    if (length) {
        let sum = 0;
        let index = length;

        while (index--) {
            sum += _previousDeltas[index];
        }

        _fps = sum / length;
    }
}

/**
 * @return {void}
 */
export function DebugGuiAddFolder(name: string, onCreate: (folder: GUI) => void): void
{
    onCreate(_gui.addFolder(name));
}

/**
 * @return {void}
 */
export function DebugInit(): void
{
    _gui = new GUI;
}
